// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import Toasted from "vue-toasted";
import moment from "moment";

import "v-slim-dialog/dist/v-slim-dialog.css";
import dialogs from "v-slim-dialog";
Vue.use(dialogs);
import VueSimpleMarkdown from "vue-simple-markdown";
import "vue-simple-markdown/dist/vue-simple-markdown.css";
Vue.use(VueSimpleMarkdown);
import VueShortKey from "vue-shortkey";
Vue.use(VueShortKey);

import {
  store
} from "./store/index";
Vue.use(BootstrapVue);
Vue.use(Toasted, {
  iconPack: "fontawesome"
});
Vue.prototype.$moment = moment;

Vue.config.productionTip = false;

// Filter koji vraca substring od prvih 20 karaktera sa tri tacke na kraju
Vue.filter("filter20Chars", value => {
  if (!value) return "";
  value = value.toString();
  if (value.length <= 20) return value;
  return value.substring(0, 20) + "...";
});

Vue.mixin({
  methods: {
    parseTime (date) {
      return this.$moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    localToUTC (date) {
      const offset = this.getOffset(true);

      if (!date || date === "") {
        return undefined;
      }

      return this.$moment(date).
        add(offset, "minutes").
        format("YYYY-MM-DD HH:mm:ss");
    },
    utcToLocal (date) {
      const offset = this.getOffset();

      if (!date || date === "") {
        return undefined;
      }

      // let rel = this.relativeTime(date);
      // console.log(rel)

      return this.$moment(date).
        add(offset, "minutes").
        format("YYYY-MM-DD HH:mm");
    },
    utcToLocalSeconds (date) {
      const offset = this.getOffset();

      if (!date || date === "") {
        return undefined;
      }

      return this.$moment(date).
        add(offset, "minutes").
        format("YYYY-MM-DD HH:mm:ss");
    },
    getOffset (keepSameOffset) {
      let offset = `${new Date().getTimezoneOffset()}`;
      if (keepSameOffset) {
        return offset;
      }

      if (offset.startsWith("-")) {
        offset = offset.replace("-", "+");
      } else if (offset.startsWith("+")) {
        offset = offset.replace("+", "-");
      }

      return offset;
    },

    relativeTime (date) {
      // let retDate = "";
      const currentDate = new moment(),
        parsedDate = new moment(date),

        daysDiff = this.$moment().range(currentDate, parsedDate).
          diff("days");
      if (daysDiff > 3) {
        return parsedDate.fromNow();
      }

      return null;

      // if (parsedDate.year() === currentDate.year()) {}

      // console.log(currentDate.year);
    },

    parseYearMoment (dateFromDB) {
      if (!dateFromDB) {
        return null
      }

      return this.$moment(this.utcToLocal(dateFromDB)).format("YYYY");
    },
    parseMonthMomentUTCFix (dateFromDB) {
      if (!dateFromDB) {
        return null
      }

      return this.$moment(this.utcToLocal(dateFromDB)).format('MMM');
    },
    isSameYear (dateFromDB) {
      if (!dateFromDB) {
        return null
      }

      const yearComp =
        this.$moment(this.utcToLocal(dateFromDB)).format("YYYY") ===
        this.$moment().year();

      return yearComp;
    },
  },
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store: store,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js